"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptPolicy = void 0;
var AcceptPolicy_1 = require("./AcceptPolicy");
Object.defineProperty(exports, "AcceptPolicy", { enumerable: true, get: function () { return __importDefault(AcceptPolicy_1).default; } });
